$(document).ready(function () {
    var $this = $('.delivery-time-js');
    var time_lable = $this.attr("data-timelable").split(','),
        week_lable = $this.attr("data-daysweek").split(',');
    var $counter = $this.find('[data-js-text-countdown-counter]'),
        $date = $this.find('[data-js-text-countdown-delivery]'),
        reset_time = +$this.attr('data-reset-time'),
        delivery_time = +$this.attr('data-delivery-time'),
        hideZero = $this.attr('data-hidezero') || true,
        date_counter = new Date(),
        structure = [
            ['hours', time_lable[0]],
            ['minutes', time_lable[1]]
        ],
        days_of_week = [
            week_lable[0],
            week_lable[1],
            week_lable[2],
            week_lable[3],
            week_lable[4],
            week_lable[5],
            week_lable[6]
        ],
        date_now,
        date_delivery,
        delivery_html,
        format,
        prop,
        time,
        postfix;

    date_counter.setDate(date_counter.getDate() + 1);
    date_counter.setHours(reset_time, 0, 0, 0);


    var t = $counter.countdown(date_counter, function (e) {
        format = '';
        delivery_html = '';

        for (var i = 0; i < structure.length; i++) {
            prop = structure[i][0];
            time = e.offset[prop];
            postfix = structure[i][1];

            if (i === 0 && time === 0 && hideZero === true) {
                continue;
            }

            if (i !== 0) {
                format += ' ';
            }

            format += time + ' ' + postfix;
        }

        $(this).html(format);

        date_delivery = new Date();
        date_delivery.setDate(date_delivery.getDate() + delivery_time);

        date_now = new Date();

        if (date_now.getHours() >= date_counter.getHours() && date_now.getMinutes() >= date_counter.getMinutes() && date_now.getSeconds() >= date_counter.getSeconds()) {
            date_delivery.setDate(date_delivery.getDate() + 1);
        }

        delivery_html += days_of_week[date_delivery.getDay()];
        delivery_html += ' ';
        delivery_html += ('0' + date_delivery.getDate()).slice(-2) + '/' + ('0' + (date_delivery.getMonth() + 1)).slice(-2) + '/' + date_delivery.getFullYear();

        $date.html(delivery_html);
    });
});